export const EXISTING_EQUIPMENT_QUESTION_PROMPT_KEY =
  'step_existing_equipment_question_prompt';

export const EXISTING_EQUIPMENT_QUESTION_PROMPT_FALLBACK =
  'Do you have an existing HVAC system at your {structureSubtype}?';

export const EXISTING_EQUIPMENT_QUESTION_PROMPT_PTAC_KEY =
  'step_existing_equipment_question_prompt_ptac';

export const EXISTING_EQUIPMENT_QUESTION_PROMPT_PTAC_FALLBACK =
  'Are you replacing existing PTAC units at your {structureSubtype}?';

export const EXISTING_EQUIPMENT_QUESTION_PROMPT_STRUCTURE_FALLBACK = 'home';

export function existingEquipmentQuestionPromptText(isPtac: boolean): {
  key: string;
  fallback: string;
} {
  return isPtac
    ? {
        key: EXISTING_EQUIPMENT_QUESTION_PROMPT_PTAC_KEY,
        fallback: EXISTING_EQUIPMENT_QUESTION_PROMPT_PTAC_FALLBACK
      }
    : {
        key: EXISTING_EQUIPMENT_QUESTION_PROMPT_KEY,
        fallback: EXISTING_EQUIPMENT_QUESTION_PROMPT_FALLBACK
      };
}

export function formatExistingEquipmentQuestionPrompt(
  template: string,
  structureSubtypeLabel: string
): string {
  const label =
    structureSubtypeLabel.trim() ||
    EXISTING_EQUIPMENT_QUESTION_PROMPT_STRUCTURE_FALLBACK;
  return template
    .replaceAll('{structureSubtype}', label)
    .replaceAll('{structureType}', label);
}
